// extracted by mini-css-extract-plugin
export default {"selectedTokenCard":"SelectedTokenCard_selectedTokenCard__1RVYW","selectedTokenContainer":"SelectedTokenCard_selectedTokenContainer__6RhkZ"};